/* Sticky, slim, and quiet — this replaces a 280px rail, so it has to earn its
   height. One row, 44px of chrome, and it never competes with the bands. */
.bar {
  position: sticky; top: 0; z-index: 40;
  background: color-mix(in srgb, var(--panel) 92%, transparent);
  backdrop-filter: saturate(1.4) blur(8px);
  border-bottom: 1px solid var(--rule);
}
.inner {
  display: flex; align-items: center; gap: 2px;
  /* The cap matches whatever view sits below, so the breadcrumb lines up with
     the content it navigates: 1080 for the reader's acts, wider for a quiz or
     a trial. App sets these per route; the defaults are the reader's. */
  max-width: var(--nav-max, calc(var(--measure) + 56px));   /* aligned with the reader's column */ margin: 0 auto; padding: 0 var(--nav-pad, 28px);
  height: 44px;
  /* No overflow:hidden here — it clipped the jump menus, which are absolutely
     positioned inside this row. The segments ellipsize themselves, which is
     what the clipping was for. */
  min-width: 0;
}

/* The root of the breadcrumb, and the answer to "how do I get out of here?".
   Given its own weight so it reads as an exit rather than another crumb. */
.home {
  display: inline-flex; align-items: center; gap: 6px; flex: none;
  border: none; background: none; cursor: pointer;
  padding: 5px 9px; border-radius: var(--radius-sm);
  font: 500 12.5px var(--sans); color: var(--ink-68);
  transition: background-color .12s ease, color .12s ease;
}
.home:hover { background: var(--ink-08); color: var(--ink); }
.homeArrow { font-size: 13px; line-height: 1; }

.segWrap { position: relative; display: inline-flex; min-width: 0; flex: 0 1 auto; }
.seg {
  display: inline-flex; align-items: center; gap: 7px;
  border: none; background: none; cursor: pointer;
  padding: 5px 9px; border-radius: var(--radius-sm);
  font: 500 12.5px var(--sans); color: var(--ink-68);
  max-width: 30ch; min-width: 0; transition: background-color .12s ease, color .12s ease;
}
.seg:hover, .segOpen { background: var(--ink-08); color: var(--ink); }
.segLabel { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.caret { flex: none; opacity: .6; }

/* the lesson segment — still a control, but the one you are actually on, so it
   carries the weight the old static label used to */
.segCurrent { font-weight: 600; color: var(--ink); max-width: 40ch; }

/* a level with no siblings to offer — a label, not a dead control */
.segStatic {
  padding: 5px 4px; font: 500 12.5px var(--sans); color: var(--ink-68);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 34ch;
}
.segStaticCurrent { font-weight: 600; color: var(--ink); max-width: 40ch; }
.sep { flex: none; color: var(--ink-30); margin: 0 3px; }
.spacer { flex: 1; }
.meta {
  font: 400 10px var(--mono); letter-spacing: .14em; text-transform: uppercase;
  color: var(--ink-45); white-space: nowrap;
}

/* jump menu */
.menu {
  position: absolute; top: calc(100% + 6px); left: 0; z-index: 50;
  /* max-content, not shrink-to-fit: the menu is absolutely positioned inside
     .segWrap, which is only as wide as its button, so plain shrink-to-fit
     resolves against ~120px and collapses the menu to its floor — wrapping
     every label onto two lines. max-content sizes to the rows and lets
     max-width do the capping. */
  width: max-content; min-width: 300px; max-width: 400px;
  max-height: 60vh; overflow-y: auto;
  padding: 6px; border-radius: var(--radius-lg);
  background: var(--paper); border: 1px solid var(--rule);
  box-shadow: 0 10px 30px rgba(18, 18, 18, .18), 0 2px 6px rgba(18, 18, 18, .08);
}
.menuRight { left: auto; right: 0; }
.item {
  display: flex; align-items: baseline; gap: 12px; width: 100%;
  padding: 8px 10px; border: none; background: none; cursor: pointer;
  border-radius: var(--radius-sm); text-align: left;
  font: 400 13px var(--sans); color: var(--ink);
}
.item:hover:not(:disabled) { background: var(--hover); }
.itemCurrent { box-shadow: inset 2px 0 0 var(--accent); font-weight: 600; }
.itemLocked { opacity: .42; cursor: default; }
.itemLabel { flex: 1; min-width: 0; }
.itemMeta { font: 400 10.5px var(--mono); color: var(--ink-45); white-space: nowrap; }

@media (max-width: 760px) {
  .inner { padding: 0 16px; gap: 0; }   /* one gutter on phones, whatever the view */
  .segStatic, .segStaticCurrent { max-width: 16ch; }
  .seg { max-width: 18ch; }
  .segCurrent { max-width: 20ch; }
  .meta { display: none; }
}
